module.exports = __webpack_public_path__ + "static/media/bpd_youtube_thumbnail.c7a249ce.png";